import React from 'react';
import type { StockStatusEnum } from '@petsmart-ui/sparky';
import { Button } from '@petsmart-ui/sparky';
import { usePageLayout } from '@libs/common-next';

import StoreInfo from './StoreInfo';
import './InStoreOnly.scss';

type InStoreOnlyProps = {
    stockStatus: StockStatusEnum;
};
export default function InStoreOnly({ stockStatus }: InStoreOnlyProps) {
    const { selectedStore, setStoreDrawerOpen } = usePageLayout();

    return (
        <div className="in-store-only" data-testid="test-in-story-only">
            <span className="in-store-only__title sparky-u-theme-typography-body-lg-bold">
                Available in-store only
            </span>
            {selectedStore && <StoreInfo stockStatus={stockStatus} />}
            <Button
                text={selectedStore ? 'Change store' : 'Check store'}
                variant="link"
                className="change-store-btn"
                onClick={() => setStoreDrawerOpen({ pageType: 'pdp' })}
            />
        </div>
    );
}
